const dev = process.env.NODE_ENV === 'development'

function getRootId() {
  const rootId = sessionStorage.getItem('rootId') || ''
  return rootId ? `/${rootId}` : ''
}

export default [
  {
    productCode: 'JW_system',
    // authDevPath: () => 'http://jw.yachedu.com/api/account/app-login',
    authDevPath: () => `/api/account/app-login`,
    authPath: () => '/api/account/app-login',
    authorization:
      'Basic MzcwMDgyNTVkZjM5OGYxYTYwMjU4ZTJjNDFlYWNhOTU6ZGRkYTQ1MDY0NjYwYWFjYTY2ZGMyZTExMWY4MTIwYjY=',
    postData: (gPersonId, name, productCode) => {
      return {
        grant_type: 'password',
        g_person_id: gPersonId,
        name: name
      }
    },
    getRole: loginRes => loginRes.account.role,
    getLoginResData: loginRes => loginRes
  },
  {
    productCode: 'MeetingRoom',
    authDevPath: () =>
      dev
        ? `/MeetingRoom/organizations${getRootId()}/oauth2/token`
        : `http://meeting-room-api-dev.informing.cn/MeetingRoom${getRootId()}/oauth2/token`,
    authPath: () => `/MeetingRoom/organizations${getRootId()}/oauth2/token`,
    authorization: '',
    postData: (gPersonId, name, productCode) => {
      return {
        grant_type: 'password',
        username: gPersonId,
        password: name,
        client_id: 'meeting-room',
        client_secret: 'ed830bf90b431836',
        product_code: productCode
      }
    },
    getRole: loginRes => loginRes[0].person.roles[0].product_code,
    getLoginResData: loginRes => loginRes[0]
  },
  {
    title: '交办督办',
    productCode: 'Todo',
    authDevPath: () =>
      dev
        ? `/Todo/organizations${getRootId()}/oauth2/token`
        : `http://todo-api-dev.informing.cn/Todo${getRootId()}/oauth2/token`,
    authPath: () => `/Todo/organizations${getRootId()}/oauth2/token`,
    authorization: '',
    postData: (gPersonId, name, productCode) => {
      return {
        grant_type: 'password',
        username: gPersonId,
        password: name,
        client_id: 'meeting-room',
        client_secret: 'ed830bf90b431836',
        product_code: productCode
      }
    },
    // getRole: (loginRes) => loginRes[0].person.roles[0].product_code,
    getRole: () => '',
    getLoginResData: loginRes => loginRes[0],
    rootId: '/451'
  },
  {
    productCode: 'Itinerary',
    authDevPath: () =>
      dev
        ? `/Itinerary/organizations${getRootId()}/oauth2/token`
        : `http://todo-api-dev.informing.cn/Itinerary${getRootId()}/oauth2/token`,
    authPath: () => `/Itinerary/organizations${getRootId()}/oauth2/token`,
    authorization: '',
    postData: (gPersonId, name, productCode) => {
      return {
        grant_type: 'password',
        username: gPersonId,
        password: name,
        client_id: 'meeting-room',
        client_secret: 'ed830bf90b431836',
        product_code: productCode
      }
    },
    // getRole: (loginRes) => loginRes[0].person.roles[0].product_code,
    getRole: () => '',
    getLoginResData: loginRes => loginRes[0],
    rootId: '/451'
  },
  {
    productCode: 'Notice',
    authDevPath: () =>
      dev
        ? `/Notice/organizations${getRootId()}/oauth2/token`
        : `http://todo-api-dev.informing.cn/Todo${getRootId()}/oauth2/token`,
    authPath: () => `/Notice/organizations${getRootId()}/oauth2/token`,
    authorization: '',
    postData: (gPersonId, name, productCode) => {
      return {
        grant_type: 'password',
        username: gPersonId,
        password: name,
        client_id: 'meeting-room',
        client_secret: 'ed830bf90b431836',
        product_code: productCode
      }
    },
    getRole: loginRes => loginRes[0].person.roles[0].product_code,
    getLoginResData: loginRes => loginRes[0]
  },
  {
    productCode: 'ZhiHuiContacts',
    authDevPath: () =>
      dev
        ? `/Todo/organizations${getRootId()}/oauth2/token`
        : `http://todo-api-dev.informing.cn/Todo${getRootId()}/oauth2/token`,
    authPath: () => `/Todo/organizations${getRootId()}/oauth2/token`,
    authorization: '',
    postData: (gPersonId, name, productCode) => {
      return {
        grant_type: 'password',
        username: gPersonId,
        password: name,
        client_id: 'meeting-room',
        client_secret: 'ed830bf90b431836',
        product_code: 'Todo' /* productCode */
      }
    },
    // getRole: (loginRes) => loginRes[0].person.roles[0].product_code,
    getRole: () => '',
    getLoginResData: loginRes => loginRes[0]
  },
  {
    productCode: 'Feedback',
    authDevPath: () =>
      dev
        ? `/Feedback/organizations${getRootId()}/oauth2/token`
        : `http://todo-api-dev.informing.cn/Todo${getRootId()}/oauth2/token`,
    authPath: () => `/Feedback/organizations${getRootId()}/oauth2/token`,
    authorization: '',
    postData: (gPersonId, name, productCode) => {
      return {
        grant_type: 'password',
        username: gPersonId,
        password: name,
        client_id: 'meeting-room',
        client_secret: 'ed830bf90b431836',
        product_code: productCode
      }
    },
    // getRole: (loginRes) => loginRes[0].person.roles[0].product_code,
    getRole: () => '',
    getLoginResData: loginRes => loginRes[0]
  },
  {
    productCode: 'ZhiHuiSmsNotice',
    authDevPath: () =>
      dev
        ? `/Todo/organizations${getRootId()}/oauth2/token`
        : `http://todo-api-dev.informing.cn/Todo${getRootId()}/oauth2/token`,
    authPath: () => `/Todo/organizations${getRootId()}/oauth2/token`,
    authorization: '',
    postData: (gPersonId, name, productCode) => {
      return {
        grant_type: 'password',
        username: gPersonId,
        password: name,
        client_id: 'meeting-room',
        client_secret: 'ed830bf90b431836',
        product_code: 'Todo' /* productCode */
      }
    },
    // getRole: (loginRes) => loginRes[0].person.roles[0].product_code,
    getRole: () => '',
    getLoginResData: loginRes => loginRes[0]
  },
  {
    productCode: 'HonestReport',
    authDevPath: () =>
      dev
        ? `/HonestReport/oauth2/token`
        : `http://todo-api-dev.informing.cn/Todo${getRootId()}/oauth2/token`,
    authPath: () => `/HonestReport/oauth2/token`,
    authorization:
      'Basic anctaG9uZXN0LXJlcG9ydC1zeXN0ZW06MzgwOTVkMzU2OTEyOTg3YjRhZGI2NjRjMGViNGY0MjY=',
    postData: (gPersonId, name, productCode) => {
      return {
        grant_type: 'password',
        username: gPersonId,
        password: name,
        product_code: productCode
      }
    },
    getRole: loginRes => loginRes.person.roles[0].product_code,
    getLoginResData: loginRes => loginRes
  },
  {
    productCode: 'LeaveRequest',
    authDevPath: () =>
      dev
        ? `/LeaveRequest/organizations${getRootId()}/oauth2/token`
        : `http://todo-api-dev.informing.cn/Todo${getRootId()}/oauth2/token`,
    authPath: () => `/LeaveRequest/organizations${getRootId()}/oauth2/token`,
    authorization: '',
    postData: (gPersonId, name, productCode) => {
      return {
        grant_type: 'password',
        username: gPersonId,
        password: name,
        client_id: 'leave-request',
        client_secret: '44c017a0b9530e09',
        product_code: 'LeaveRequest' || productCode
      }
    },
    getRole: loginRes => loginRes[0].person.roles.map(i => i.product_code).toString(),
    // getRole: () => '',
    getLoginResData: loginRes => loginRes[0]
  }
]



// WEBPACK FOOTER //
// ./src/dev-variable/auth-config.js